import { render, staticRenderFns } from "./AlertIcon.vue?vue&type=template&id=76d86928&"
import script from "./AlertIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AlertIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports